import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

const LANGUAGES = { en: 'English', tr: 'Türkçe' };

const LanguageSwitcher = ({ variant = 'dark', className = '', selectClassName = '', fullWidth = false }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.split('-')[0] || 'en';
  const wrapperClass = [
    styles.wrapper,
    variant === 'light' && styles.wrapperLight,
    fullWidth && styles.wrapperFullWidth,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClass}>
      <select
        className={[
          styles.select,
          fullWidth && styles.selectFullWidth,
          selectClassName,
        ].filter(Boolean).join(' ')}
        value={currentLang}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        aria-label="Select language"
      >
        <option className={styles.option} value="en">English</option>
        <option className={styles.option} value="tr">Türkçe</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
